import { PropsWithChildren } from "react";
import { AuthenticationProvider } from "core/iam/AuthenticationProvider";
import { SessionDetector } from "core/iam/SessionDetector";
import { ReduxProvider } from "providers/core/ReduxProvider";
import { TanstackQueryProvider } from "providers/core/TanstackQueryProvider";
import { InternationalizationProvider } from "providers/core/InternationalizationProvider";
import { MuiThemeProvider } from "providers/core/MuiThemeProvider";
import { LegacyMuiLocalizationProvider } from "providers/core/LegacyMuiLocalizationProvider";
import { NotistackSnackbarProvider } from "providers/core/NotistackSnackbarProvider";
import { ErrorBoundary } from "lib/error/ErrorBoundary";
import { LegacyViewCountTrackerProvider } from "providers/core/LegacyViewCountTrackerProvider";
import { LocaleUpdater } from "providers/core/LocaleUpdater";

export function AppProviders(props: PropsWithChildren) {
  return (
    <TanstackQueryProvider>
      <AuthenticationProvider>
        <ReduxProvider>
          <InternationalizationProvider>
            <SessionDetector>
              <MuiThemeProvider>
                <LegacyMuiLocalizationProvider>
                  <NotistackSnackbarProvider>
                    <ErrorBoundary useDefaultFallback>
                      <LegacyViewCountTrackerProvider>
                        <LocaleUpdater />
                        {props.children}
                      </LegacyViewCountTrackerProvider>
                    </ErrorBoundary>
                  </NotistackSnackbarProvider>
                </LegacyMuiLocalizationProvider>
              </MuiThemeProvider>
            </SessionDetector>
          </InternationalizationProvider>
        </ReduxProvider>
      </AuthenticationProvider>
    </TanstackQueryProvider>
  );
}
